import moment from 'moment';
import { formatting } from '../pipes/format-date.pipe';

export class BillingPeriod {
  public id: string;
  public startDate: moment.Moment;
  public endDate: moment.Moment;
  public displayString: string;

  constructor(
    public month: number,
    public year: number,
  ) {
    this.id = this.month + '-' + this.year;

    this.startDate = moment.utc().year(this.year).month(this.month).startOf('month');
    this.endDate = this.startDate.clone().endOf('month');
    this.displayString = this.startDate.format(formatting.month);
  }

  public static getCurrentBillingPeriod(): BillingPeriod {
    const today = moment().utc();
    return new BillingPeriod(today.month(), today.year());
  }

  public static getNextBillingPeriod(): BillingPeriod {
    const nextMonth = moment.utc().add(1, 'month');
    return new BillingPeriod(nextMonth.month(), nextMonth.year());
  }

  public static isValidBillingPeriod(month: number, year: number): boolean {
    return month >= 0 && month <= 11 && year > 0;
  }
}
